import apiKit from "./axios-base";
import { getLocalData, removeLocalData, storeLocalData } from '../global-storage'

const login = (username, password) => {
  return new Promise((resolve, reject) => {
    apiKit
      .post(
        "/MtUsers/login?include=user", 
        { username, password },
        {
          headers: {
            'x-client': 'admin-panel'  // ✅ tell backend this is admin panel login
          }
        }
      )
      .then(function (response) {
  const user = response.data.user;
  const isAdmin = user?.userType === "ADMIN";
  const isSubAdmin = user?.userType === "SUB_ADMIN";

  if (isAdmin || isSubAdmin) {
    storeLocalData("accessToken", response.data.id);
    storeLocalData("userId", response.data.userId);
    storeLocalData("authUser", JSON.stringify(user));

    // ⭐ Store permissions of SUB_ADMIN (array)
    if (isSubAdmin) {
      storeLocalData("permissions", JSON.stringify(user.permissions || []));
    } else {
      // ADMIN has full access → store wildcard
      storeLocalData("permissions", JSON.stringify(["*"]));
    }

    resolve(response.data.id);
  } else {
    reject(new Error("Unauthorized: You are not allowed to access admin panel"));
  }
})

      .catch(function (error) {
        console.error(`Error: ${error}`);
        reject(error);
      });
  });
};

const signup = (contactName, contactNumber, password, email, username, isTermsAgreed, userType) => {
  const data = { contactName, contactNumber, password, email, username, isTermsAgreed, userType };

  return new Promise((resolve, reject) => {
    apiKit.post("/MtUsers", data)
      .then(function (response) {
        resolve(response.data);
        // Optional: handle navigation outside this file
      })
      .catch(function (error) {
        console.error(`Error: ${JSON.stringify(error)}`);
        reject(error);
      });
  });
};

const logout = () => {
  return new Promise((resolve, reject) => {
    apiKit
      .post("/MtUsers/logout?access_token=" + getLocalData('accessToken'))
      .then(function (response) {
        console.log("logout");
        removeLocalData("accessToken");
        removeLocalData("authUser");
        removeLocalData("userId");
        removeLocalData("auth_token");
        resolve(response);
      })
      .catch(function (error) {
        console.error(`Error: ${error}`);
        reject(error);
      });
  });
};

export const authenticationService = {
  login,
  signup,
  logout
};
